enum LineItem {
  deductible = 'Deductible',
  part = 'Part',
  labour = 'Labour',
  other = 'Other',
}

export default LineItem;
